module.exports = __webpack_public_path__ + "img/planet_04.77f91533.png";